import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  MenuItem,
  Select,
  Checkbox,
  ListItemText,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function LevelTable({
  xpLevelSettings,
  storePackOptions,
  trainingLevelOptions,
  DAILY_WAIT_OPTIONS,
  TRAINING_WAIT_OPTIONS,
  packPullError,
  coinsPullError,
  handleChange,
  handleDeleteRow,
  handleAddCardRow,
  handleAddCoinRow,
  selectedCardType,
  setSelectedCardType,
  originalSettings,
  editingStartIndex,
  setEditingStartIndex,
  editingEndIndex,
  setEditingEndIndex,
  isViewer,
}) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Level</TableCell>
            <TableCell>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <img
                  src="/assets/icons/xp-level.svg"
                  alt="Edit Icon"
                  style={{ width: "20px", height: "20px" }}
                />
                <span>Start</span>
              </Box>
            </TableCell>
            <TableCell>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <img
                  src="/assets/icons/xp-level.svg"
                  alt="Edit Icon"
                  style={{ width: "20px", height: "20px" }}
                />
                <span>End</span>
              </Box>
            </TableCell>
            <TableCell>Daily Login Pack Pull</TableCell>
            <TableCell>Daily Login Coins Pull</TableCell>
            <TableCell>Daily Wait Time</TableCell>
            <TableCell>Store Packs</TableCell>
            <TableCell>Training Level</TableCell>
            <TableCell>Training Wait Time</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {xpLevelSettings.map((level, index) => (
            <TableRow key={level.levelId || index}>
              <TableCell sx={{ verticalAlign: "top" }}>
                {level.levelName}
              </TableCell>
              <TableCell sx={{ verticalAlign: "top" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {editingStartIndex === index ? (
                    <input
                      type="number"
                      value={level.rewardStart}
                      onChange={(e) =>
                        handleChange(index, "rewardStart", e.target.value)
                      }
                      onBlur={() => setEditingStartIndex(null)}
                      autoFocus
                      style={{ width: "60px" }}
                    />
                  ) : (
                    <>
                      <span>{level.rewardStart}</span>
                      {!isViewer && (
                        <img
                          src="/assets/icons/EditIcon.svg"
                          alt="Edit Icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginLeft: "4px",
                            cursor: "pointer",
                          }}
                          onClick={() => setEditingStartIndex(index)}
                        />
                      )}
                    </>
                  )}
                </Box>
              </TableCell>
              <TableCell sx={{ verticalAlign: "top" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {editingEndIndex === index ? (
                    <input
                      type="number"
                      value={level.rewardEnd}
                      onChange={(e) =>
                        handleChange(index, "rewardEnd", e.target.value)
                      }
                      onBlur={() => setEditingEndIndex(null)}
                      autoFocus
                      style={{ width: "60px" }}
                    />
                  ) : (
                    <>
                      <span>{level.rewardEnd}</span>
                      {!isViewer && (
                        <img
                          src="/assets/icons/EditIcon.svg"
                          alt="Edit Icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginLeft: "4px",
                            cursor: "pointer",
                          }}
                          onClick={() => setEditingEndIndex(index)}
                        />
                      )}
                    </>
                  )}
                </Box>
              </TableCell>

              <TableCell>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {Object.entries(
                    level.settings?.DailyFreePack?.CardPull || {}
                  ).map(([cardType, cardValue]) => (
                    <Box
                      key={cardType + index}
                      sx={{ display: "flex", gap: 1, alignItems: "center" }}
                    >
                      <select
                        value={selectedCardType[index]?.[cardType] ?? cardType}
                        onChange={(e) =>
                          setSelectedCardType((prev) => ({
                            ...prev,
                            [index]: {
                              ...prev[index],
                              [cardType]: e.target.value,
                            },
                          }))
                        }
                        disabled={
                          !!originalSettings[index]?.settings?.DailyFreePack
                            ?.CardPull?.[cardType]
                        }
                        style={{
                          width: "70px",
                          padding: "4px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      >
                        {["Gold", "Silver", "Base", "AllStar"].map((type) => (
                          <option
                            key={type}
                            disabled={
                              type !== cardType &&
                              !!level.settings?.DailyFreePack?.CardPull?.[type]
                            }
                          >
                            {type}
                          </option>
                        ))}
                      </select>

                      <input
                        type="number"
                        value={cardValue ?? ""}
                        onChange={(e) =>
                          handleChange(
                            index,
                            `settings.DailyFreePack.CardPull.${cardType}`,
                            e.target.value
                          )
                        }
                        style={{
                          width: "60px",
                          padding: "4px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                      {!isViewer && (
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleDeleteRow(index, "Card", cardType)
                          }
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                  ))}

                  <Button
                    variant="text"
                    size="small"
                    disabled={
                      Object.keys(
                        xpLevelSettings[index].settings.DailyFreePack
                          .CardPull || {}
                      ).length >= 4
                    }
                    onClick={() => handleAddCardRow(index)}
                  >
                    + Add Row
                  </Button>

                  {packPullError[index] && (
                    <Typography
                      color="error"
                      variant="caption"
                      sx={{
                        maxWidth: 150,
                        display: "block",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {packPullError[index]}
                    </Typography>
                  )}
                </Box>
              </TableCell>

              <TableCell>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {Object.entries(
                    level.settings?.DailyFreePack?.CoinsPull || {}
                  ).map(([key, value]) => (
                    <Box
                      key={key + index}
                      sx={{ display: "flex", gap: 1, alignItems: "center" }}
                    >
                      <input
                        type="text"
                        defaultValue={key}
                        onBlur={(e) => {
                          const newKey = e.target.value;
                          if (newKey !== key) {
                            const newSettings = [...xpLevelSettings];
                            const coinsPull =
                              newSettings[index].settings.DailyFreePack
                                .CoinsPull;
                            coinsPull[newKey] = coinsPull[key];
                            delete coinsPull[key];
                            handleChange(
                              index,
                              `settings.DailyFreePack.CoinsPull.${newKey}`,
                              coinsPull[newKey]
                            );
                          }
                        }}
                        style={{
                          width: "100px",
                          padding: "4px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />

                      <input
                        type="number"
                        value={value}
                        onChange={(e) =>
                          handleChange(
                            index,
                            `settings.DailyFreePack.CoinsPull.${key}`,
                            e.target.value
                          )
                        }
                        style={{
                          width: "60px",
                          padding: "4px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                      {!isViewer && (
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteRow(index, "Coin", key)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                  ))}
                  <Button
                    variant="text"
                    size="small"
                    onClick={() => handleAddCoinRow(index)}
                  >
                    + Add Row
                  </Button>
                  {coinsPullError[index] && (
                    <Typography
                      color="error"
                      variant="caption"
                      style={{
                        maxWidth: 150,
                        display: "block",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {coinsPullError[index]}
                    </Typography>
                  )}
                </Box>
              </TableCell>

              <TableCell sx={{ verticalAlign: "top" }}>
                <Select
                  size="small"
                  value={level.settings?.DailyFreePack?.PackFrequencyHrs || ""}
                  onChange={(e) =>
                    handleChange(
                      index,
                      "settings.DailyFreePack.PackFrequencyHrs",
                      e.target.value
                    )
                  }
                >
                  {DAILY_WAIT_OPTIONS.map((opt) => {
                    const hours = opt.replace("hr", "");
                    return (
                      <MenuItem key={opt} value={hours}>
                        {opt}
                      </MenuItem>
                    );
                  })}
                </Select>
              </TableCell>

              <TableCell sx={{ verticalAlign: "top" }}>
                <FormControl size="small" style={{ width: 130, minWidth: 0 }}>
                  <Select
                    multiple
                    value={level.settings?.Packs?.Available || []}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "settings.Packs.Available",
                        e.target.value
                      )
                    }
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {storePackOptions.map((pack) => (
                      <MenuItem key={pack} value={pack}>
                        <Checkbox
                          checked={
                            level.settings?.Packs?.Available?.indexOf(pack) > -1
                          }
                        />
                        <ListItemText primary={pack} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>

              <TableCell sx={{ verticalAlign: "top" }}>
                <FormControl size="small" style={{ width: 130, minWidth: 0 }}>
                  <Select
                    multiple
                    value={level.settings?.Training?.Combined || []}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "settings.Training.Combined",
                        e.target.value
                      )
                    }
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {trainingLevelOptions.map((levelOpt) =>
                      (level.settings?.Training?.TrainingSlots || []).map(
                        (slot) => {
                          const combo = `${levelOpt} ${slot}`;
                          return (
                            <MenuItem key={combo} value={combo}>
                              <Checkbox
                                checked={
                                  level.settings?.Training?.Combined?.indexOf(
                                    combo
                                  ) > -1
                                }
                              />
                              <ListItemText primary={combo} />
                            </MenuItem>
                          );
                        }
                      )
                    )}
                  </Select>
                </FormControl>
              </TableCell>

              <TableCell sx={{ verticalAlign: "top" }}>
                <Select
                  size="small"
                  value={level.settings?.Training?.TrainingDurationHrs || ""}
                  onChange={(e) =>
                    handleChange(
                      index,
                      "settings.Training.TrainingDurationHrs",
                      e.target.value
                    )
                  }
                >
                  {TRAINING_WAIT_OPTIONS.map((opt) => {
                    const hours = opt.replace("hrs", "");
                    return (
                      <MenuItem key={opt} value={hours}>
                        {opt}
                      </MenuItem>
                    );
                  })}
                </Select>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
